import React, {Component} from 'react'
import {Tabs, Input, Button, message, Modal, Select, AutoComplete} from 'antd';
import Helmet from "react-helmet";
import './delivery.less'
import {getPublicOrderList} from '../../api'
const {TabPane} = Tabs;
const {Option} = Select;
const logisticsStatusObj = {
    waiting: "待提货",
    transport: '运输中',
    declaring: '报关中',
    released: '已放行',
    boxed: '已装箱',
    destination: '已到达',
    cancelled: '已取消'
}
export default class DeliveryQuery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            searchValue: "",
            tabKey: 'order',
            recordNoData: [],
            dataSource: [],
            recordNo: '',
            selectMap: {},
            allData: [],
            placeholder: '请输入13位订单号',
        }
        this.pattern = /[A-Za-z]{4}\d{7}/;
    }

    orderNoClick = () => {
        const {recordNo, tabKey} = this.state;
        if (tabKey && tabKey === 'order' && ( !recordNo || recordNo.length < 13 )) {
            message.error(this.state.placeholder);
            return
        } else if (tabKey && tabKey === 'boxNo') {
            /*if( !recordNo || recordNo.length!==11 ) {
             message.error(this.state.placeholder);
             return
             }else if(!this.pattern.test(recordNo)) {
             message.error('集装箱号前4位为字母,后7位为数字');
             return
             }*/
        } else if (tabKey && tabKey === 'GPS' && ( !recordNo )) {
            message.error(this.state.placeholder);
            return
        }
        if (!recordNo) {
            message.error('请填写')
        } else {
            this.getOrderNoList(tabKey, recordNo)
        }
    }


    getOrderNoList = async (type, recordNo) => {
        let result = await getPublicOrderList(type, recordNo)
        if (result.code === 200) {
            let orderNo = "";
            let gpsNo = "";
            for (let item of result.data) {
                if (type === 'order' && item.orderNo == recordNo) {
                    orderNo = item.orderNo
                    gpsNo = item.trailNo
                    break;
                } else if (type === 'GPS' && item.trailNo.toUpperCase() == recordNo.toUpperCase()) {
                    orderNo = item.orderNo
                    gpsNo = item.trailNo
                    break;
                } else if (type === 'boxNo' && item.boxNo.toUpperCase() == recordNo.toUpperCase()) {
                    orderNo = item.orderNo
                    gpsNo = item.trailNo
                    break;
                }
            }
            if (orderNo != "" && orderNo != undefined) {
                let path = '/trackQuery/' + orderNo
                if (gpsNo && gpsNo != "") {
                    path = path + "/" + gpsNo
                }
                this.props.history.push(path)
            } else {
                if (type === 'order') {
                    message.error('订单号有误')
                } else if (type === 'GPS') {
                    message.error('GPS设备号有误')
                } else {
                    message.error('集装箱号有误')
                }
            }

        } else {
            message.error(result.message)
        }

    }

    getOrderAutoList = async (type, recordNo) => {
        if (type && type === 'order' && ( !recordNo || recordNo.length < 13 )) {
            this.setState({
                dataSource: []
            })
            return
        } else if (type && type === 'boxNo' && ( !recordNo /*|| recordNo.length < 11*/ )) {
            this.setState({
                dataSource: []
            })
            return
        } else if (type && type === 'GPS' && ( !recordNo)) {
            this.setState({
                dataSource: []
            })
            return
        } else if (!recordNo || recordNo.length < 2) {
            this.setState({
                dataSource: []
            })
            return
        }
        let result = await getPublicOrderList(type, recordNo)
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    allData: result.data
                })
                let newType = type
                if (type == "order") {
                    newType = "orderNo"
                } else if (type == "boxNo") {
                    newType = "boxNo"
                } else if (type == "GPS") {
                    newType = "trailNo"
                }
                let dataSource = []
                for (let i of result.data) {
                    if (i[newType] != undefined) {
                        if (newType === "boxNo" || newType === "trailNo") {
                            dataSource.push(i[newType] + ',' + i.collectDt + ',' + i.logisticsStatus)
                        } else {
                            dataSource.push(i[newType])
                        }
                    }
                }
                const data = new Set(dataSource);
                this.setState({
                    dataSource: Array.from(data)
                })
            }
        } else {
            this.setState({
                dataSource: []
            })
        }
    }

    tabChange = (key) => {
        if (key === 'order') {
            this.setState({
                placeholder: '请输入13位订单号'
            })
        } else if (key === 'boxNo') {
            this.setState({
                placeholder: '请输入集装箱号'
            })
        } else if (key === 'GPS') {
            this.setState({
                placeholder: '请输入GPS'
            })
        }
        this.setState({
            selectMap: Object.assign(this.state.selectMap, {[this.state.tabKey]: this.state.searchValue})
        });
        this.setState({
            searchValue: this.state.selectMap[key]
        });
        this.setState({
            tabKey: key
        })
    }
    renderOption = (item) => {
        let trailNo = item;
        let collectDt = '';
        let logisticsStatus = '';
        if (item.indexOf(',') > 0) {
            trailNo = item.split(',')[0];
            collectDt = item.split(',')[1];
            logisticsStatus = item.split(',')[2];
        }
        return (
            <Option key={item} text={trailNo} date={collectDt} code={logisticsStatus}>
                <div className="global-search-item">
                    {logisticsStatus === 'transport' ?
                        <span className="global-search-item-desc" style={{color: 'black'}}>
                         {trailNo} {collectDt ? collectDt + '发货' : ''} {logisticsStatusObj[logisticsStatus]}
                        </span> :
                        <span className="global-search-item-desc">
                         {trailNo} {collectDt ? collectDt + '发货' : ''} {logisticsStatusObj[logisticsStatus]}
                        </span>
                    }
                </div>
            </Option>
        );
    }
    onFocus = value => {
        const {tabKey} = this.state
        this.getOrderAutoList(tabKey, value)
    }
    onSearch = value => {
        this.setState({
            searchValue: value,
            recordNo: value
        });
        const {tabKey} = this.state
        this.getOrderAutoList(tabKey, value)
    }
    //option为renderOption中的option对象
    onSelect = (value, option) => {
        let type = this.state.tabKey;
        let orderNo = '';
        let gpsNo = '';
        if (type == "order") {
            type = "orderNo"
        } else if (type == "boxNo") {
            type = "boxNo"
        } else if (type == "GPS") {
            type = "trailNo"
        }
        for (let i of this.state.allData) {
            if ((type === 'boxNo' || type === 'trailNo' ) && option) {
                if (i[type] == option.props.text && i.collectDt === option.props.date) {
                    orderNo = i["orderNo"];
                    gpsNo = i["trailNo"];
                    break
                }
            } else if (i[type] == value) {
                orderNo = i["orderNo"];
                gpsNo = i["trailNo"];
                break
            }
        }
        let path = '/trackQuery/' + orderNo
        if (gpsNo && gpsNo != "") {
            path = path + "/" + gpsNo
        }
        this.props.history.push(path)
    }

    render() {
        const {tabKey, dataSource, searchValue} = this.state;
        const autoCompleteEnter = (control) => {
            if (control) {
                control.select.rcSelect.onInputKeyDown = (e) => {
                    if (e.keyCode == 13) {
                        control.select.rcSelect.setOpenState(false, true);
                        this.orderNoClick()
                        return;
                    }
                }
            }
        };
        return (
            <div className='deleveryQuery'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                />
                <div className="logo"><a href="www.55train.com"></a></div>
                <div className="delivery-content">
                    <div className='delivery-content-title'>
                        <p>跨境货运物流轨迹查询</p>
                        <p className='en'>LOGISTICS TRACK QUERY</p>
                    </div>
                    <Tabs defaultActiveKey={tabKey} onChange={this.tabChange}>
                        <TabPane tab="订单号" key="order">
                        </TabPane>
                        <TabPane tab="集装箱号" key="boxNo">
                        </TabPane>
                        <TabPane tab="GPS设备号" key="GPS">
                        </TabPane>
                    </Tabs>
                    {
                        <div>
                            <AutoComplete
                                dataSource={dataSource.map(this.renderOption)}
                                optionLabelProp="text"
                                style={{width: '80%', height: '50px'}}
                                onFocus={this.onFocus}
                                onSearch={this.onSearch}
                                onSelect={this.onSelect}
                                value={searchValue}
                                //  defaultActiveFirstOption={false}
                                ref={autoCompleteEnter}
                                placeholder={this.state.placeholder}
                            />
                            <Button type='primary' onClick={this.orderNoClick}>查询</Button>
                        </div>
                    }
                </div>
                <div className='delivery-content-footer'>
                    浙ICP备16022887号-2
                </div>
            </div>
        )
    }
}